module.exports = __webpack_public_path__ + "img/icon__arrow--yellow.svg";